import { render, staticRenderFns } from "./Extensiones.vue?vue&type=template&id=38982899&"
import script from "./Extensiones.vue?vue&type=script&lang=js&"
export * from "./Extensiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports